var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-in_svg__b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign-in_svg__d",
    x1: 10.94,
    y1: 12.74,
    x2: 21.06,
    y2: 12.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign-in_svg__c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.79,25.83c2.25-2.4,3.63-5.62,3.63-9.16,0-7.4-6.02-13.42-13.42-13.42S2.58,9.27,2.58,16.67c0,3.51,1.36,6.72,3.58,9.11.06.1.15.19.24.26,2.44,2.5,5.84,4.05,9.6,4.05s7.1-1.53,9.53-3.99c.1-.07.19-.16.26-.27ZM16,4.99c6.44,0,11.68,5.24,11.68,11.68,0,2.41-.74,4.66-1.99,6.52-.78-2.8-3.36-4.86-6.4-4.86h-6.6c-3.03,0-5.6,2.04-6.39,4.82-1.25-1.86-1.97-4.09-1.97-6.49,0-6.44,5.24-11.68,11.68-11.68Zm-3.31,15.1h6.6c2.69,0,4.88,2.19,4.89,4.88v.04c-2.11,2.07-5,3.35-8.18,3.35s-6.09-1.29-8.21-3.38c0-2.69,2.2-4.88,4.89-4.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.87,9.49c-.96-1.15-2.38-1.81-3.87-1.81-2.79,0-5.06,2.27-5.06,5.06s2.27,5.06,5.06,5.06,5.06-2.27,5.06-5.06c0-1.19-.42-2.34-1.18-3.25Zm-3.87-.05c.98,0,1.9.43,2.53,1.18.5.59.77,1.34.77,2.12,0,1.82-1.48,3.3-3.3,3.3s-3.3-1.48-3.3-3.3,1.48-3.3,3.3-3.3Z",
    fill: "url(#sign-in_svg__d)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 32,
    height: 32,
    fill: "#fff",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.636be87b068555c30a71c24de6e2cc70.svg";
export { ForwardRef as ReactComponent };